import { PrimeReactPTOptions } from "primereact/api";
import { MenubarPassThroughMethodOptions } from "primereact/menubar";
import { classNames } from "primereact/utils";

import { isInIframe } from "@/features/auth/helpers/isInIframe";

type ThroughMethodOptions = MenubarPassThroughMethodOptions & {
  context: ContextMenuItem;
};

type ContextMenuItem = {
  active: boolean;
  focused: boolean;
  level: number;
};

export const menubar: PrimeReactPTOptions["menubar"] = {
  root: {
    className: classNames(
      "p-2 sm:p-0 sm:pl-4 border-b  border-[#E4E4E4] flex items-center relative",
      { "sm:pl-0": isInIframe() },
    ),
  },
  menu: ({ state }: ThroughMethodOptions) => {
    return {
      className: classNames(
        "m-0 sm:p-0 list-none",
        "outline-none",
        "sm:flex items-center flex-wrap sm:flex-row sm:top-auto sm:left-auto sm:relative sm:bg-transparent sm:shadow-none sm:w-auto",
        "flex-col top-full left-0",
        "absolute py-1 bg-white dark:bg-gray-900 border-0 shadow-md w-full",
        {
          "hidden ": !state?.mobileActive,
          "flex ": state?.mobileActive,
        },
      ),
    };
  },
  menuitem: ({ context }: ThroughMethodOptions) => {
    return {
      className: classNames(
        "sm:relative sm:w-auto w-full static",
        "transition-shadow duration-200",
        { "md:py-[0.2rem] text-[0.875rem]": context?.level === 0 },
        { "py-0 text-[0.75rem] md:first:mt-2 md:last:mb-2": context?.level > 0 },
        {
          "text-rdc-gray": !context.active,
          "bg-rdc-primaryLight text-rdc-primary": context.active || context.focused,
        },
        {
          "hover:text-gray-700 hover:bg-[#DBE2EC]": !context.active,
          "hover:bg-rdc-primaryLight": context.active,
        },
      ),
    };
  },
  action: ({ context }: ThroughMethodOptions) => ({
    className: classNames(
      "select-none",
      "cursor-pointer flex items-center no-underline overflow-hidden relative gap-[0.5rem]",
      "py-2 px-4 select-none",
      {
        "pl-9 sm:pl-5": context.level === 1,
        "pl-14 sm:pl-5": context.level === 2,
      },
    ),
  }),
  submenu: ({ context }: ThroughMethodOptions) => {
    return {
      className: classNames(
        "bg-white dark:bg-gray-900 border-0  sm:shadow-md sm:w-48",
        "w-full static shadow-none",
        "sm:absolute z-10",
        "m-0 list-none",
        {
          "sm:absolute sm:left-full sm:top-0": context?.level > 1,
        },
      ),
    };
  },
  submenuIcon: ({ context }: ThroughMethodOptions) => {
    return {
      className: classNames("transition w-[16px] h-[16px]", { "rotate-180": context.active }),
    };
  },
  button: {
    className: classNames(
      "flex sm:hidden rounded-full text-gray-600 dark:text-white/80 transition duration-200 ease-in-out",
      "cursor-pointer flex items-center justify-center no-underline",
      "0 hover:bg-rdc-primaryLight  p-2",
      "focus:outline-none focus:outline-offset-0",
    ),
  },
  end: ["sm:mr-3"],
};
